import { graphql } from "react-relay"

import { NoteCreateMutation } from "./__generated__/NoteCreateMutation.graphql"
import { NoteDeleteMutation } from "./__generated__/NoteDeleteMutation.graphql"
import { NoteUpdateMutation } from "./__generated__/NoteUpdateMutation.graphql"

import { environment } from "~/store/hasura"

import { commitMutationPromise } from "./helpers"

const noteCreateMutation = graphql`
  mutation NoteCreateMutation($note: ProjectNoteCreateInput!) {
    action_project_note_create(input: $note) {
      note {
        id
        note
        created_by
        creator_email
        created_at
        project_id
        user_id
        user_account {
          id
          user {
            id
            first_name
            last_name
            email
          }
        }
      }
      project {
        id
        notes(order_by: { created_at: asc }) {
          id
        }
        notes_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
`

export const noteCreateRelay = (variables: NoteCreateMutation["variables"]) => {
  return commitMutationPromise<NoteCreateMutation>(environment, {
    mutation: noteCreateMutation,
    variables,
  })
}

const noteUpdateMutation = graphql`
  mutation NoteUpdateMutation($note: ProjectNoteUpdateInput!) {
    action_project_note_update(input: $note) {
      note {
        id
        note
        created_by
        creator_email
        updated_at
        user_id
        user_account {
          id
          user {
            id
            first_name
            last_name
            email
          }
        }
      }
    }
  }
`

export const noteUpdateRelay = (variables: NoteUpdateMutation["variables"]) => {
  return commitMutationPromise<NoteUpdateMutation>(environment, {
    mutation: noteUpdateMutation,
    variables,
  })
}

const noteDeleteMutation = graphql`
  mutation NoteDeleteMutation($id: Int!) {
    deleteNote(id: $id) {
      project {
        id
        notes(order_by: { created_at: asc }) {
          id
        }
        notes_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
`

export const noteDeleteRelay = (variables: NoteDeleteMutation["variables"]) => {
  return commitMutationPromise<NoteDeleteMutation>(environment, {
    mutation: noteDeleteMutation,
    variables,
  })
}
